import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import {Videos, ChannelCard} from './';
import { fetchFromAPI } from "../utils/fetchFromAPI";

const ChannelDetail = () => {
  const { id } = useParams();
  const [channelDetail, setChannelDetail] = useState(null);
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    fetchFromAPI(`search?part=snippet&channelId=${id}&order=date`)
    .then((data) => setVideos(data.items));

    fetchFromAPI(`channels?part=snippet&id=${id}`)
    .then((data) => setChannelDetail(data?.items[0]));

  }, [id]);
  console.log(videos);

  return (
    <Box minHeight="92vh">
      <Box>
        <div style={{
              background:'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(120,9,121,1) 0%, rgba(0,212,255,1) 100%',
              zIndex:10,
              height:"300px"    
            }} 
        />
        <ChannelCard channelDetail={ channelDetail} marginTop="-110px" />
      </Box>
      <Box display={'flex'} p="2">
        <Box sx={{mr:{sm:'100px'}}} />
            {videos && <Videos videos={videos} />}
      </Box>
    </Box>
  )
}

export default ChannelDetail